import {
  Component,
  Input,
  ViewChild,
} from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dc-control-validation',
  templateUrl: './dc-control-validation.component.html',
  styleUrls: ['./dc-control-validation.component.scss'],
})
export class DcControlValidationComponent {
  @Input() label: string;
  @Input() body: string;
  @Input() status: 'valid' | 'invalid' | '';
  @Input() class: 'required' | '';

  @ViewChild(NgbPopover)
  private popover: NgbPopover;

  constructor() {}

  show(): void {
    this.popover.open();
  }
}
